import type { FaireProductEntity } from "../../entity_types/product";

export const p_7jbwpz8afz: FaireProductEntity = {
  token: "p_7jbwpz8afz",
  type: "product",
  name: "Flower Charm, Flower Connector, Gold Plated White Enamel Flower Charm Connector, Margaret / Sunflower / Daisy Connector, Bracelet Earrings",
  brandToken: "b_gaeskeqmf8",
  brandName: "Flowerhint",
  imageUrl:
    "https://cdn.faire.com/fastly/421de5ff0a06877026607737a3cd206a1461ce0927a9a7b89b41cedc81d55c22.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.08,
  description:
    "Introducing our exquisite gold-plated white enamel flower charm connectors, featuring a delightful selection of Margaret, Sunflower, and Daisy designs. These charming connectors are perfect for creating stunning bracelets and earrings that exude elegance and style.\n\n * Gold plated with white enamel for a luxurious finish \n * Versatile connectors suitable for bracelets and earrings \n * Available in a variety of enchanting flower designs \n * Perfect for adding a touch of nature-inspired beauty to your jewelry pieces \nElevate your jewelry creations with these intricate flower connectors and infuse your designs with the timeless allure of nature's blooms.\n",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:28.213Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
